/**
 * Form Input Components for Alpine.js
 */

export function MetricInputComponent(config = {}) {
    return {
        currentValue: config.value || 0,
        lastValue: config.lastValue || null,
        isDirty: false,
        zone: config.zone,

        init() {
            window.addEventListener('metric-changed', (e) => {
                if (e.detail.name === this.zone) {
                    this.currentValue = e.detail.value;
                    this.isDirty = true;
                }
            });

            window.addEventListener('metrics-saved', () => {
                this.isDirty = false;
            });
        },

        get delta() {
            if (this.lastValue === null || !this.currentValue) return null;
            return (this.currentValue - this.lastValue).toFixed(1);
        },
    };
}

export function StepperInputComponent(config = {}) {
    return {
        value: config.value || 0,
        min: config.min ?? 0,
        max: config.max ?? 1000,
        step: config.step ?? 1,

        increment() {
            this.value = Math.min(this.max, +(this.value + this.step).toFixed(2));
            this.sync();
        },

        decrement() {
            this.value = Math.max(this.min, +(this.value - this.step).toFixed(2));
            this.sync();
        },

        sync() {
            this.$nextTick(() => {
                // Dispatch change event to notify HTMX or other listeners
                this.$refs.input.dispatchEvent(new Event('change', { bubbles: true }));
            });
        },
    };
}
